import { Skeleton } from "@xola/ui-kit";
import clsx from "clsx";
import { range, uniqueId } from "lodash";
import React from "react";

export const SkeletonLine = ({ className }: { className?: string }) => {
    // There is intentionally no content in the div. Just set your parent component to the right size
    return <div className={clsx("h-6 w-full rounded bg-gray-lighter", className)} />;
};

interface TableSkeletonProps {
    columns?: number;
    rows?: number;
    className?: string;
}

export const TableSkeleton = ({ rows = 5, columns = 9, className }: TableSkeletonProps) => {
    return (
        <Skeleton
            height="100%"
            classNames={{ container: clsx("pb-10 w-full !border-none !bg-white", className), text: "w-full" }}
        >
            {range(0, rows).map((value) => (
                <div
                    key={uniqueId(String(value))}
                    className={`grid grid-cols-${columns} grid-cols-auto mb-2 w-full gap-x-2`}
                >
                    {range(0, columns).map((index) => (
                        <div key={uniqueId(String(index))} className="h-6 bg-gray-lighter" />
                    ))}
                </div>
            ))}
        </Skeleton>
    );
};
